import {get} from 'lodash/fp';

import {Rank} from '/constant/TestIDs';
import {
  GLOBAL_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
  NATIONAL_DIRECTOR,
  PRESIDENTIAL_DIRECTOR,
  REGIONAL_DIRECTOR,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {showComingSoonToast} from '/util/toast.util';

import PeopleData from '../../PeopleData';
import PeopleExtendedData from '../../PeopleExtendedData';
import {PersonStats} from '../personStats';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.executiveDirectorTeams.${key}`, value);

export default {
  dataComponent: PeopleData,
  dataComponentProps: {
    getPeople: get('coaches'),
    getTitle: (target: any) => {
      return target <= 1
        ? tt('title.incomplete.singular', 'Executive Director Team')
        : tt('title.incomplete.plural', 'Executive Director Teams');
    },
    personIsCoach: true,
  },
  extendedDataComponent: PeopleExtendedData,
  extendedDataComponentProps: {
    getPeople: get('coaches'),
    personIsCoach: true,
    getVacantName: () => tt('vacancyPosition', 'Executive Director'),
    getVacancyCta: () =>
      tt('vacancyCta', 'See Who’s Close To Executive Director'),
    getPersonDescription: () => tt('position', 'Executive Director'),
    getPersonStats: (data: any) =>
      PersonStats(
        {
          subheaderFirst: tt('orderingEntities', 'Ordering Entities'),
          subheaderSecond: tt('gqv', 'GQV'),
          count: data.orderingEntitiesCount,
          target: data.orderingEntitiesTarget,
        },
        data,
      ),
    onVacancyCtaPress: () =>
      showComingSoonToast('rank progress close to ed rank'),
  },
  isComplete: ({currentCount: current, target}: any) => current >= target,
  hasExtendedDetail: true,
  presentedFor: [
    REGIONAL_DIRECTOR,
    NATIONAL_DIRECTOR,
    GLOBAL_DIRECTOR,
    PRESIDENTIAL_DIRECTOR,
    INTEGRATED_REGIONAL_DIRECTOR,
    INTEGRATED_NATIONAL_DIRECTOR,
  ],
  testID: Rank.rankExecutiveDirectorTeams,
};
